import { Controller } from "@hotwired/stimulus"
import Noty from "noty"

export default class extends Controller {
  static values = {
    type: String,
    message: String
  }

  connect() {
    if (this.messageValue) {
      this.show(this.messageValue, this.typeValue)
    }
  }

  show(message, type = "success") {
    new Noty({
      text: message,
      type: type === "alert" || type === "error" ? "error" : "success",
      layout: "topRight",
      theme: "mint",
      timeout: type === "error" ? false : 4000,
      progressBar: true,
      closeWith: ["click", "button"],
      animation: {
        open: "noty_effects_open",
        close: "noty_effects_close"
      }
    }).show()
  }
}
